import { render, staticRenderFns } from "./IpsCalendar.vue?vue&type=template&id=1432895a"
import script from "./IpsCalendar.vue?vue&type=script&lang=js"
export * from "./IpsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports